module.exports = __webpack_public_path__ + "static/media/augmentsite-high-resolution-logo-transparent.3dfedfd9.png";